<template>
  <header class="app-header" :class="[
      {'app-header--active': showMobileMenu},
      {'app-header--scrolled': isScrolled},
      `app-header--${headerTheme}`
    ]">
    <!-- Logo部分（PC和Mobile共用） -->
    <a class="app-header__logo" :href="getNavLink('/')">
      <img :src="domainConfig?.['siteIcon']" class="app-header__logo-icon" alt="site logo">
      <div class="app-header__logo-text" :class="[
          {'app-header__logo-text--active': showMobileMenu},
        ]">
        {{domainConfig?.['siteName']}}</div>
    </a>

    <!-- PC导航菜单 (只在桌面设备显示) -->
    <nav class="app-header__nav" v-if="deviceType === 'desktop' || deviceType === 'pc'">
      <div v-for="(item, index) in navItems" :key="index"
        class="app-header__nav-wrapper" :class="[{'app-header__nav-wrapper--active': isRouteActive(item.link)}]">
        <a :href="getNavLink(item.link)"
          class="app-header__nav-item" :class="[
            {'app-header__nav-item--active': isRouteActive(item.link)},
            `app-header__nav-item--${headerTheme}`,
            {'app-header__nav-item--scrolled': isScrolled}
          ]">
          {{ item.name }}
        </a>
      </div>
    </nav>

    <!-- Mobile菜单按钮 (只在移动设备显示) -->
    <div class="app-header__mobile-trigger" @click="toggleMobileMenu">
      <img v-if="!showMobileMenu" :src="menuSrc" alt="menu">
      <img v-else src="@/assets/clos-menu.svg" alt="close menu">
    </div>

    <!-- Mobile菜单 (显示/隐藏取决于showMenu) -->
    <div class="app-header__mobile-menu " v-if="showMobileMenu">
      <div class="app-header__mobile-menu-container">
        <div class="app-header__mobile-menu-list">
          <a v-for="(item, index) in navItems" :key="index" :href="getNavLink(item.link)"
            class="app-header__mobile-menu-item" :class="[{'app-header__mobile-menu-item--active': isRouteActive(item.link)}]"
            @click="showMobileMenu = false">
            <span>{{ item.name }}</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="10" viewBox="0 0 24 10" fill="none">
              <path d="M19.6112 10H16.3112C16.0733 10 15.9535 9.66313 16.1219 9.46625L19.9432 5L16.1214 0.533125C15.9529 0.336875 16.0727 0 16.3107 0H19.6106C19.8235 0 20.0272 0.0987495 20.178 0.274374L23.8432 4.55812C24.0523 4.8025 24.0523 5.19813 23.8432 5.44188L20.1785 9.725C20.0277 9.90125 19.824 10 19.6112 10ZM4.13548 9.725L7.80012 5.44188C8.00921 5.1975 8.00921 4.80187 7.80012 4.55812L4.13494 0.274374C3.98468 0.0987495 3.78094 0 3.56811 0H0.268158C0.0301937 0 -0.0895905 0.336875 0.078856 0.53375L3.90019 5L0.078856 9.46625C-0.0895905 9.66313 0.0296589 10 0.268158 10H3.56811C3.78094 10 3.98521 9.90125 4.13548 9.725ZM12.1567 9.725L15.8214 5.44188C16.0305 5.1975 16.0305 4.80187 15.8214 4.55812L12.1562 0.274374C12.0065 0.0987495 11.8022 0 11.5894 0H8.28942C8.05146 0 7.93167 0.336875 8.10012 0.53375L11.922 5L8.10065 9.46625C7.93221 9.66313 8.05146 10 8.28942 10H11.5894C11.8027 10 12.0065 9.90125 12.1567 9.725Z" fill="#e2372d"/>
            </svg>
          </a>
          
          <!-- 额外资源链接 -->
          <a :href="getNavLink('/terms-of-services')" class="app-header__mobile-menu-item" @click="showMobileMenu = false">
            <span>Terms of Services</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="10" viewBox="0 0 24 10" fill="none">
              <path d="M19.6112 10H16.3112C16.0733 10 15.9535 9.66313 16.1219 9.46625L19.9432 5L16.1214 0.533125C15.9529 0.336875 16.0727 0 16.3107 0H19.6106C19.8235 0 20.0272 0.0987495 20.178 0.274374L23.8432 4.55812C24.0523 4.8025 24.0523 5.19813 23.8432 5.44188L20.1785 9.725C20.0277 9.90125 19.824 10 19.6112 10ZM4.13548 9.725L7.80012 5.44188C8.00921 5.1975 8.00921 4.80187 7.80012 4.55812L4.13494 0.274374C3.98468 0.0987495 3.78094 0 3.56811 0H0.268158C0.0301937 0 -0.0895905 0.336875 0.078856 0.53375L3.90019 5L0.078856 9.46625C-0.0895905 9.66313 0.0296589 10 0.268158 10H3.56811C3.78094 10 3.98521 9.90125 4.13548 9.725ZM12.1567 9.725L15.8214 5.44188C16.0305 5.1975 16.0305 4.80187 15.8214 4.55812L12.1562 0.274374C12.0065 0.0987495 11.8022 0 11.5894 0H8.28942C8.05146 0 7.93167 0.336875 8.10012 0.53375L11.922 5L8.10065 9.46625C7.93221 9.66313 8.05146 10 8.28942 10H11.5894C11.8027 10 12.0065 9.90125 12.1567 9.725Z" fill="#e2372d"/>
            </svg>
          </a>
          <a :href="getNavLink('/privacy-policy')" class="app-header__mobile-menu-item" @click="showMobileMenu = false">
            <span>Privacy Policy</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="10" viewBox="0 0 24 10" fill="none">
              <path d="M19.6112 10H16.3112C16.0733 10 15.9535 9.66313 16.1219 9.46625L19.9432 5L16.1214 0.533125C15.9529 0.336875 16.0727 0 16.3107 0H19.6106C19.8235 0 20.0272 0.0987495 20.178 0.274374L23.8432 4.55812C24.0523 4.8025 24.0523 5.19813 23.8432 5.44188L20.1785 9.725C20.0277 9.90125 19.824 10 19.6112 10ZM4.13548 9.725L7.80012 5.44188C8.00921 5.1975 8.00921 4.80187 7.80012 4.55812L4.13494 0.274374C3.98468 0.0987495 3.78094 0 3.56811 0H0.268158C0.0301937 0 -0.0895905 0.336875 0.078856 0.53375L3.90019 5L0.078856 9.46625C-0.0895905 9.66313 0.0296589 10 0.268158 10H3.56811C3.78094 10 3.98521 9.90125 4.13548 9.725ZM12.1567 9.725L15.8214 5.44188C16.0305 5.1975 16.0305 4.80187 15.8214 4.55812L12.1562 0.274374C12.0065 0.0987495 11.8022 0 11.5894 0H8.28942C8.05146 0 7.93167 0.336875 8.10012 0.53375L11.922 5L8.10065 9.46625C7.93221 9.66313 8.05146 10 8.28942 10H11.5894C11.8027 10 12.0065 9.90125 12.1567 9.725Z" fill="#e2372d"/>
            </svg>
          </a>
          <a :href="getNavLink('/disclaimer')" class="app-header__mobile-menu-item" @click="showMobileMenu = false">
            <span>Disclaimer</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="10" viewBox="0 0 24 10" fill="none">
              <path d="M19.6112 10H16.3112C16.0733 10 15.9535 9.66313 16.1219 9.46625L19.9432 5L16.1214 0.533125C15.9529 0.336875 16.0727 0 16.3107 0H19.6106C19.8235 0 20.0272 0.0987495 20.178 0.274374L23.8432 4.55812C24.0523 4.8025 24.0523 5.19813 23.8432 5.44188L20.1785 9.725C20.0277 9.90125 19.824 10 19.6112 10ZM4.13548 9.725L7.80012 5.44188C8.00921 5.1975 8.00921 4.80187 7.80012 4.55812L4.13494 0.274374C3.98468 0.0987495 3.78094 0 3.56811 0H0.268158C0.0301937 0 -0.0895905 0.336875 0.078856 0.53375L3.90019 5L0.078856 9.46625C-0.0895905 9.66313 0.0296589 10 0.268158 10H3.56811C3.78094 10 3.98521 9.90125 4.13548 9.725ZM12.1567 9.725L15.8214 5.44188C16.0305 5.1975 16.0305 4.80187 15.8214 4.55812L12.1562 0.274374C12.0065 0.0987495 11.8022 0 11.5894 0H8.28942C8.05146 0 7.93167 0.336875 8.10012 0.53375L11.922 5L8.10065 9.46625C7.93221 9.66313 8.05146 10 8.28942 10H11.5894C11.8027 10 12.0065 9.90125 12.1567 9.725Z" fill="#e2372d"/>
            </svg>
          </a>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'AppHeader',
  props: {
    headerTheme: {
      type: String,
      default: 'dark' // 可选值：'light'或'dark'
    },
  },
  computed: {
    ...mapGetters({
      deviceType: 'deviceType',
      domainConfig: 'domainConfig'
    }),
    menuSrc () {
      return this.headerTheme === 'dark'
        ? require('@/assets/mobile-menu-dark.svg')
        : require('@/assets/mobile-menu.svg');
    }
  },
  data () {
    return {
      showMobileMenu: false,
      isScrolled: false, // 新增：跟踪滚动状态
      scrollThreshold: 50, // 滚动阈值，超过该值会触发header样式变化
      navItems: [
        { name: 'Home', link: '/' },
        { name: 'All Cars', link: '/car-list' },
        { name: 'Rankings', link: '/car-rank' },
        { name: 'About Us', link: '/about' },
      ]
    };
  },
  methods: {
    toggleMobileMenu () {
      this.showMobileMenu = !this.showMobileMenu;

      // 如果打开菜单，禁止body滚动
      if (this.showMobileMenu) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    },

    // 判断当前路由是否激活
    isRouteActive (link) {
      // 获取不包含channel参数的当前路径
      let currentPath = this.$route.path;
      const channel = this.$route.params.channel;

      // 如果存在channel参数，移除channel部分以便正确比较
      if (channel && currentPath.startsWith(`/${channel}`)) {
        currentPath = currentPath.replace(`/${channel}`, '') || '/';
      }

      // 处理根路径特殊情况
      if (link === '/' && (currentPath === '/' || currentPath === '')) {
        return true;
      }

      // 其他情况检查路径是否匹配（排除根路径情况）
      if (link !== '/') {
        return currentPath.startsWith(link);
      }

      return false;
    },

    // 获取导航链接
    getNavLink (link) {
      // 获取当前URL的查询参数
      const currentQuery = this.$route.query;
      const queryString = Object.keys(currentQuery).length > 0
        ? `?${new URLSearchParams(currentQuery).toString()}`
        : '';

      // 检查是否存在channel参数
      if (this.$route.params.channel) {
        // 如果是首页链接
        if (link === '/') {
          return `/${this.$route.params.channel}${queryString || ''}`;
        }
        // 其他链接
        return `/${this.$route.params.channel}${link}${queryString}`;
      }
      return `${link}${queryString}`;
    },

    // 处理滚动事件
    handleScroll () {
      this.isScrolled = window.scrollY > this.scrollThreshold;
    }
  },
  beforeDestroy () {
    // 确保在组件销毁时恢复body滚动
    document.body.style.overflow = '';
    // 移除滚动事件监听
    window.removeEventListener('scroll', this.handleScroll);
  },
  mounted () {
    // 监听路由变化，关闭移动菜单
    this.$router.afterEach(() => {
      if (this.showMobileMenu) {
        this.showMobileMenu = false;
        document.body.style.overflow = '';
      }
    });

    // 添加滚动事件监听
    window.addEventListener('scroll', this.handleScroll);
    // 初始化滚动状态
    this.handleScroll();
  }
};
</script>

<style lang="scss">
@import '~@/css/variables.scss';

// 使用命名空间避免样式冲突
.app-header {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	z-index: 100;
	display: flex;
	align-items: center;
	justify-content: space-between;
	box-sizing: border-box;
	height: rem(80);
	padding: 0 rem(180);
	transition: background-color 0.3s ease, box-shadow 0.3s ease;
	background: #000000;

	&__logo {
		display: flex;
		align-items: center;
		cursor: pointer;
		gap: rem(16);
		z-index: 100; // 确保在移动菜单上方
		flex: none;
	}

	&__logo-icon {
		width: rem(40);
		height: rem(40);
		background: #fff;
		border-radius: 50%;
		padding: rem(4);
		box-sizing: border-box;
		object-fit: contain;
	}

	&__logo-text {
		color: #ffffff !important;
		text-align: left;
		font-family: 'Inter-Black', sans-serif;
		font-size: rem(24);
		line-height: rem(24);
		font-weight: 900;
		text-transform: none;
	}

	&__nav {
		display: flex;
		gap: rem(32);
		align-items: center;
	}

	&__nav-wrapper {
		border-radius: rem(8);
		padding: rem(8) rem(16);
		display: flex;
		align-items: center;
		justify-content: center;
		transition: all 0.3s ease;

		&--active {
			background: #e2372d;
		}
	}

	&__nav-item {
		color: #ffffff !important;
		text-align: left;
		font-family: 'Inter-Medium', sans-serif;
		font-size: rem(14);
		line-height: rem(16);
		font-weight: 500;
		text-decoration: none;
		transition: all 0.3s ease;

		&--active {
			font-weight: 800;
			font-family: 'Inter-ExtraBold', sans-serif;
		}

		&:hover {
			opacity: 0.8;
		}
	}

	// 移动设备菜单按钮
	&__mobile-trigger {
		width: rem(32);
		height: rem(32);
		display: none;
		cursor: pointer;
		z-index: 100;
		// filter: brightness(0) invert(1); // 移动端三横线图标也设为白色

		@media (max-width: 767px) {
			display: block;
		}
	}

	&__mobile-menu {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100vh;
		background: rgba(0, 0, 0, 0.6); // 半透明背景
		z-index: 99;
		display: flex;
		justify-content: center;
		align-items: flex-start;
    padding-top: rem(70);
		backdrop-filter: blur(10px); // 毛玻璃效果
	}

	&__mobile-menu-container {
		width: calc(100% - rem(40));
		max-height: 80vh;
		background: linear-gradient(180deg, rgba(226, 55, 45, 0) 0%, rgba(226, 55, 45, 0.3) 100%);
		border-radius: rem(24);
		border: 1px solid rgba(255, 255, 255, 0.1);
		padding: rem(24);
		overflow-y: auto;
		display: flex;
		flex-direction: column;
		gap: rem(32);
    border-radius: rem(20);
    border: rem(1) solid rgba(255, 255, 255, 0.10);
    background: linear-gradient(180deg, #E2372D 0%, rgba(226, 55, 45, 0.20) 100%);
    box-shadow: 0 rem(4) rem(12) 0 rgba(0, 0, 0, 0.24);
    border-bottom: none;
	}

	&__mobile-menu-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		.app-header__logo {
			flex: none;
		}
	}

	&__mobile-close {
		cursor: pointer;
	}

	&__mobile-menu-list {
		display: flex;
		flex-direction: column;
		gap: rem(12);
	}

	&__mobile-menu-item {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: rem(16) rem(20);
		background: #141414;
		border-radius: rem(12);
		border: 1px solid rgba(255, 255, 255, 0.1);
		text-decoration: none;
		color: #ffffff;
		font-size: rem(16);
		font-weight: 500;
		transition: all 0.3s ease;

		// &--active {
		// 	border-color: #e2372d;
		// 	background: linear-gradient(90deg, rgba(226, 55, 45, 0.2) 0%, #141414 100%);
		// }

		span {
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}

		svg {
			flex-shrink: 0;
		}
	}

	@media (max-width: 1200px) {
		padding: 0 rem(40);
	}

	@media (max-width: 767px) {
		padding: 0 rem(20);
		height: rem(70);

		&__logo-text {
			font-size: rem(20);
		}

		&__nav {
			display: none;
		}
	}
}

// PC端基础样式
.detect_deviece_pc,
.detect_deviece_desktop {
	.app-header {
		position: relative;
		padding: 0 rem(180);
		height: rem(80);
	}
}

// 移动端基础样式
.detect_deviece_mobile {
	.app-header {
		padding: 0 rem(20);
		height: rem(70);

		&__logo-text {
			font-size: rem(20);
		}

		&__nav {
			display: none;
		}

		&__mobile-trigger {
			display: block;
		}
	}
}
</style>
